export type TrackType = 'primaryRefi' | 'secondInvestPurch'

export interface TrackDates {
  initialLE: string
  signCD: string
  close: string
}

export interface ImportantDatesState {
  primaryRefi: TrackDates
  secondInvestPurch: TrackDates
}

// Periods are keyed by "YYYY-MM" so admins can prep many future months at once.
export type PeriodKey = string
export type MonthlyDates = Record<PeriodKey, ImportantDatesState>

export interface CalendarEvent {
  id: string
  title: string
  date: string
  calendar: string
  track: TrackType
  milestone: string
  period: PeriodKey
}

export const emptyTrackDates: TrackDates = {
  initialLE: '',
  signCD: '',
  close: '',
}

export const emptyDatesState: ImportantDatesState = {
  primaryRefi: { ...emptyTrackDates },
  secondInvestPurch: { ...emptyTrackDates },
}
